module.exports = __webpack_public_path__ + "static/media/create_paper.2ebc6509.png";